import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { UserCreationDialogComponent } from "./user-creation-dialog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { InputSelectModule } from "@shared/components/input-select/input-select.module";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { InputAutocompleteModule } from "@shared/components/input-autocomplete/input-autocomplete.module";
import { SharedModule } from "@shared/shared.module";
import { SelectModule } from "../select/select.module";
import { PipesModule } from "src/app/shared/pipes/pipes.module";

@NgModule({
	declarations: [UserCreationDialogComponent],
	imports: [
		CommonModule,
		FlexLayoutModule,
		FormsModule,
		InputAutocompleteModule,
		InputWrapperModule,
		InputSelectModule,
		MatInputModule,
		MatButtonModule,
		MatDialogModule,
		MatFormFieldModule,
		MatIconModule,
		ReactiveFormsModule,
		SharedModule,
		SelectModule,
		PipesModule
	]
})
export class UserCreationDialogModule {}
